"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const Button_1 = require("@material-ui/core/Button");
const Dialog_1 = require("@material-ui/core/Dialog");
const DialogActions_1 = require("@material-ui/core/DialogActions");
const DialogContent_1 = require("@material-ui/core/DialogContent");
const DialogContentText_1 = require("@material-ui/core/DialogContentText");
const DialogTitle_1 = require("@material-ui/core/DialogTitle");
const styles_1 = require("@material-ui/core/styles");
const classnames_1 = require("classnames");
const _ = require("lodash");
const React = require("react");
const react_i18next_1 = require("react-i18next");
const config_1 = require("../../../config/config");
const TicketScreenStyle_1 = require("../../jss/TicketScreenStyle");
const OptOutConfirmationDialog = ({ onGoBack, onOk, currentConfirmItem, classes }) => {
    const [show, setShow] = React.useState(false);
    const { t } = (0, react_i18next_1.useTranslation)();
    const optOut = currentConfirmItem.preference.optOut;
    const drawName = currentConfirmItem.drawName;
    const entries = currentConfirmItem.entries;
    const optInMessage = currentConfirmItem.optInMessage;
    const optOutMessage = currentConfirmItem.optOutMessage;
    React.useEffect(() => {
        setShow(!!currentConfirmItem);
    }, [currentConfirmItem]);
    const goBack = () => {
        setShow(false);
        onGoBack();
    };
    const ok = () => {
        setShow(false);
        onOk();
    };
    const title = optOut ? t('ticket.confirmOptOutTitle') : t('ticket.confirmOptInTitle');
    let content;
    if (optOut) {
        if (!!optOutMessage) {
            content = _.replace(optOutMessage, '{{name}}', drawName || '');
            content = _.replace(content, '{{entries}}', entries && entries > 0 ? `${entries}` : '');
        }
        else {
            content = t('ticket.confirmOptOutMessage', { count: entries, name: drawName });
        }
    }
    else {
        if (!!optInMessage) {
            content = _.replace(optInMessage, '{{name}}', drawName || '');
            content = _.replace(content, '{{entries}}', entries && entries > 0 ? `${entries}` : '');
        }
        else {
            content = t('ticket.confirmOptInMessage', { count: entries, name: drawName });
        }
    }
    const comment = optOut ? t('ticket.confirmOptOutComment') : t('ticket.confirmOptInComment');
    return ((0, jsx_runtime_1.jsxs)(Dialog_1.default, Object.assign({ fullWidth: true, maxWidth: "sm", open: show, onClose: goBack, className: (0, classnames_1.default)(classes.dialogBackdrop, 'po-widget-dialog'), PaperProps: {
            className: (0, classnames_1.default)(classes.verticalPadding, classes.dialog)
        } }, { children: [(0, jsx_runtime_1.jsx)(DialogTitle_1.default, { children: title }), (0, jsx_runtime_1.jsxs)(DialogContent_1.default, { children: [(0, jsx_runtime_1.jsx)(DialogContentText_1.default, { children: content.replace(/&#39;/gi, `'`) }), (0, jsx_runtime_1.jsx)(DialogContentText_1.default, Object.assign({ style: { marginTop: 16 } }, { children: comment }))] }), (0, jsx_runtime_1.jsxs)(DialogActions_1.default, { children: [(0, jsx_runtime_1.jsx)(Button_1.default, Object.assign({ color: config_1.config.internalConfig.BUTTON_BACKGROUND, size: 'large', variant: 'text', className: 'textButton', onClick: goBack }, { children: t('buttons.goBack') })), (0, jsx_runtime_1.jsx)(Button_1.default, Object.assign({ color: config_1.config.internalConfig.BUTTON_BACKGROUND, size: 'large', variant: 'contained', className: 'containedButton', onClick: ok }, { children: t('buttons.ok') }))] })] })));
};
exports.default = (0, styles_1.withStyles)(TicketScreenStyle_1.default)(OptOutConfirmationDialog);
//# sourceMappingURL=OptOutConfirmationDialog.js.map